export default __webpack_public_path__ + "static/media/placeholder_portfolio02-fr-mobile.b184a049.png";